import React, { Component } from "react";
import _ from "lodash";
import { Button, Modal, FormControl, FormGroup } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import TimeStamp from "react-timestamp";
import * as reactDeviceDetect from "react-device-detect";
import { fire, auth } from "../../firebase/index";
import { customLog } from "../../variables/Variables";
import "../../assets/css/maincss.css";
import "../../assets/css/header.css";
import LocalizedStrings from "react-localization";
// Icons
import accountManagement from "../../assets/img/AccountManagement.png";
import lockAccess from "../../assets/img/LockAccess.png";
import loginRequest from "../../assets/img/LoginRequest.png";
import notificationStatus from "../../assets/img/notificationStatus.png";
import paymentFail from "../../assets/img/PaymentFail.png";
import paymentFailPopup from "../../assets/img/PaymentFailPopup.png";
import authorizeIMG from "../../assets/img/Authorize.png";
import MapsTransferWithinAStation from "material-ui/svg-icons/maps/transfer-within-a-station";
import ImpactAlert from "../../assets/img/impact_alert_icon.png";

import UserSettingsPopUp from "../../assets/img/UserSettingsPopUp.png";
import memberRemoveIcon from "../../assets/img/memberRemovedPopUp.png";

//import localization
//Localization codes
let localizationStrings = new LocalizedStrings({
  en: {
    permissionTitle: "Approval Request",
    descriptionTitle: "New device login",
    approvalAllow: "Approved",
    approvalDeny: "Denie2d",
    approvalPending: "Pending",
    detailsTitle: "Details",
    paymentDetailsTitle: "Payment details",
    viewDetailsTitle: "View Details",
    allow: "Approve",
    deny: "Deny",
    noDataTitle: "There is no data to display",
    accountNotifType: "Account Management",
    lockNotifType: "Lock Access",
    loginNotifType: "Login Request",
    detailsNotifType: "Notification details",
    paymentFailNotifType: "Payment Declined",
    EmailHeader: "Email:",
    DeviceHeader: "Device:",
    TimeHeader: "Time:",
    StatusHeader: "Status:",
    SenderHeader: "Sender:",
    noDeviceTitle: "New device",
    deniedButton: "DENIED",
    approvedButton: "APPROVED",
    expiredButton: "EXPIRED",
    invalidButton: "INVALID",
    pendingButton: "PENDING",
    PopupTextBullet1: "Insufficient funds on the account",
    PopupTextBullet2: "Expired credit card",
    PopupTextBullet3: "The bank’s fraud rules blocked the transaction",
    PopupButton: "Update details",
    PopupButtonClose: "Close",
    paymentFailPopupDescription:
      "An attempt to renew your subscription with your current payment method has failed",
    attemptMessage3Day: "Another attempt for payment will be in 3 days",
    attemptMessage1Day:
      "Another attempt for payment will be in 1 day. Please note: If this attempt fails, your subscription will be canceled.",
    attemptMessageNone:
      "Your subscription has been canceled. Please contact eGeeTouch Support to reactivate your subscription.",
    attemptMessageNote:
      "Please verify or update your payment method to avoid losing your subscription. If your payment information is correct, please contact your bank for more details.",
    planDetail: "Plan: ",
    amountDetail: "Amount: ",
    cardDetail: "Card: ",
    dateDetail: "Date: ",
    popupTitle: "Email Update",
    emailDescription: " has updated their email.",
    emailUpdatedOn: "Updated On: ",
    oldEmailHeader: "Previous Email: ",
    newEmailHeader: "New Email: ",
    removedMember: "Information",
    removedMemberTitle: "You have been removed from ",
    memberListTitle: "'s member list.",
    removedMemberDescription: "Removed On: ",
    superAdminHeader: "Super Admin: ",
    removedMemberInformationDescription1:
      "You no longer have permission to access the IAM System.",
    removedMemberInformationDescription2:
      "To continue, you must be added to any existing super admin's member list or subscribe/redeem a plan.",
    ImpactAlert: "Strong Impact Alert",
    lockimpact:
      "Your lock has detected a strong impact. Please inspect it for any signs of physical damage to maintain security",
    Serial_Number_title: "Serial Number: ",
    Time_title: "Time: ",
    Address_title: "Address: ",
  },

  ja: {
    permissionTitle: "許可",
    descriptionTitle: "新しいデバイスのログイン",
    approvalAllow: "承認",
    approvalDeny: "アクセス拒否",
    approvalPending: "待機中",
    detailsTitle: "詳細",
    paymentDetailsTitle: "支払詳細",
    viewDetailsTitle: "詳細",
    allow: "承認",
    deny: "アクセス拒否",
    noDataTitle: "表示するデータがありません。",
    accountNotifType: "アカウント管理",
    lockNotifType: "ロックアクセス",
    loginNotifType: "ログインリクエスト",
    detailsNotifType: "通知詳細",
    paymentFailNotifType: "支払いが行われませんでした",
    EmailHeader: "メール:",
    DeviceHeader: "デバイス:",
    TimeHeader: "時間:",
    StatusHeader: "状態:",
    SenderHeader: "送信者:",
    noDeviceTitle: "新しいデバイス",
    deniedButton: "アクセス拒否",
    approvedButton: "承認",
    expiredButton: "期限切れ",
    invalidButton: "無効",
    pendingButton: "待機中",
    PopupTextBullet1: "残高不足",
    PopupTextBullet2: "クレジットカードの期限切",
    PopupTextBullet3: "銀行の不正防止ポリシー",
    PopupButton: "更新",
    PopupButtonClose: "ページを閉じる",
    paymentFailPopupDescription:
      "現在のお支払い方法ではプランの更新ができませんでした。",
    attemptMessage3Day: "3日以内に再度お支払い処理を行います。",
    attemptMessage1Day: "1日以内に再度お支払い処理を行います。",
    attemptMessageNone:
      "ご契約のプランはキャンセルされました。プランを再開するには、eGeeTouchサポート（support @ egeetouch.com）にご登録アカウントとご契約プランをご記載の上、お問い合わせください。",
    attemptMessageNote:
      "現在ご契約のプランが失効しないように、お支払い方法を確認または更新してください。お支払い情報が正しい場合は、カード会社もしくはお取引のある銀行に詳細をお問い合わせください。",
    planDetail: "プラン",
    amountDetail: "金額",
    cardDetail: "カード",
    dateDetail: "日付",
    popupTitle: "メール更新",
    emailDescription: "がメールを更新しました。",
    emailUpdatedOn: "更新日: ",
    oldEmailHeader: "以前のメール: ",
    newEmailHeader: "新しいメール: ",
    removedMember: "情報",
    removedMemberTitle: "あなたは以下から削除されました: ",
    memberListTitle: "'s メンバーリスト。",
    removedMemberDescription: "削除日: ",
    superAdminHeader: "スーパ管理者: ",
    removedMemberInformationDescription1:
      "IAMシステムへのアクセス権がなくなりました。",
    removedMemberInformationDescription2:
      "続行するには、既存のスーパ管理者のメンバーリストに追加されるか、プランを購読/引換える必要があります。",
    ImpactAlert: "衝撃感知アラーム . ",
    lockimpact:
      "ロックが衝撃を感知しました。ロケーションと時間は表示の通りです。本体と施錠状態をチェックして下さい。(本体は数分後にオートOFF機能で電源がOFFになります)",
    Serial_Number_title: "シリアルNo: ",
    Time_title: "時間: ",
    Address_title: "住所: ",
  },
  es: {
    permissionTitle: "Solicitud de Aprobación",
    descriptionTitle: "Nuevo inicio de sesión de dispositivo",
    approvalAllow: "Aprobado",
    approvalDeny: "Denegado",
    approvalPending: "Pendiente",
    detailsTitle: "Detalles",
    paymentDetailsTitle: "Detalles del pago",
    viewDetailsTitle: "Ver Detalles",
    allow: "Aprobar",
    deny: "Denegar",
    noDataTitle: "No hay datos para mostrar",
    accountNotifType: "Gestión de Cuenta",
    lockNotifType: "Acceso a la Candado",
    loginNotifType: "Solicitud de Inicio de Sesión",
    detailsNotifType: "Detalles de Notificación",
    paymentFailNotifType: "Pago Rechazado",
    EmailHeader: "Correo Electrónico:",
    DeviceHeader: "Dispositivo:",
    TimeHeader: "Tiempo:",
    StatusHeader: "Estado:",
    SenderHeader: "Remitente:",
    noDeviceTitle: "Nuevo dispositivo",
    deniedButton: "DENEGADO",
    approvedButton: "APROBADO",
    expiredButton: "EXPIRADO",
    invalidButton: "INVALIDO",
    pendingButton: "PENDIENTE",
    PopupTextBullet1: "Fondos insuficientes en la cuenta",
    PopupTextBullet2: "Tarjeta de crédito caducada",
    PopupTextBullet3:
      "Las reglas de fraude del banco bloquearon la transacción",
    PopupButton: "Actualizar detalles",
    PopupButtonClose: "Cerrar",
    paymentFailPopupDescription:
      "Un intento de renovar tu suscripción con tu método de pago actual ha fallado",
    attemptMessage3Day: "Otro intento de pago será en 3 días",
    attemptMessage1Day:
      "Otro intento de pago será en 1 día. Ten en cuenta: Si este intento falla, tu suscripción será cancelada.",
    attemptMessageNone:
      "Tu suscripción ha sido cancelada. Por favor contacta al Soporte de eGeeTouch para reactivar tu suscripción.",
    attemptMessageNote:
      "Por favor verifica o actualiza tu método de pago para evitar perder tu suscripción. Si tu información de pago es correcta, contacta a tu banco para más detalles.",
    planDetail: "Plan: ",
    amountDetail: "Monto: ",
    cardDetail: "Tarjeta: ",
    dateDetail: "Fecha: ",
    popupTitle: "Actualización de Correo Electrónico",
    emailDescription: " ha actualizado su correo electrónico.",
    emailUpdatedOn: "Actualizado el: ",
    oldEmailHeader: "Correo Electrónico Anterior: ",
    newEmailHeader: "Nuevo Correo Electrónico: ",
    removedMember: "Información",
    removedMemberTitle: "Has sido removido de ",
    memberListTitle: "'s lista de miembros.",
    removedMemberDescription: "Eliminado el: ",
    superAdminHeader: "Super Administrador: ",
    removedMemberInformationDescription1:
      "Ya no tienes permiso para acceder al Sistema IAM.",
    removedMemberInformationDescription2:
      "Para continuar, debes ser agregado a la lista de miembros de un super admin existente o suscribirte/redimir un plan.",
    ImpactAlert: "Alerta de Impacto Fuerte",
    lockimpact:
      "Tu candado ha detectado un fuerte impacto. Por favor inspeciona para cualquier signo de daño físico para mantener la seguridad",
    Serial_Number_title: "Número de Serie: ",
    Time_title: "Hora: ",
    Address_title: "Dirección: ",
  },
});

class ApprovalBtn extends Component {
  constructor(props) {
    super(props);

    const accessData = this.props.accessData;

    this.handlePopupClose = this.handlePopupClose.bind(this);
    this.handlePopupOpen = this.handlePopupOpen.bind(this);
    this.handlePopupOpen2 = this.handlePopupOpen2.bind(this);
    this.handlePopupOpen2 = this.handlePopupOpen2.bind(this);
    this.handleApproveButton = this.handleApproveButton.bind(this);
    this.handleDenyButton = this.handleDenyButton.bind(this);

    this.state = {
      accessData: accessData,
      // accessData: accessData,
      showPopup: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      accessData: nextProps.accessData,
      showPopup: false,
    });
  }

  async componentWillMount() {
    //! FOR LANGUAGE
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid) // get uid from auth person object
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            currentLanguage: snapshot.val(),
          });
        });
    }

    if (this.props.accessData.type === 3) {
      await fire
        .database()
        .ref("subscriptionPackageDetail")
        .child("PLANS")
        .once("value")
        .then((snapshot) => {
          snapshot.forEach((childSnapshot) => {
            if (
              this.state.accessData.access.plan === childSnapshot.val().plan
            ) {
              this.setState({
                currentPlan: childSnapshot.val().packageName,
              });
            }
          });
        });
    }
  }

  // componentDidMount() {
  //   this.setState({ _notificationSystem: this.refs._notificationSystem });
  // }

  getUserId = async (email) => {
    const url =
      "https://us-central1-egeetouchindustrial.cloudfunctions.net/getUserByEmail";

    let userId = "";

    await fetch(url, {
      method: "POST",
      body: JSON.stringify({ email: email }),
    }).then(async (response) => {
      const responseResult = await response.json();
      userId = responseResult.uid;
    });

    return userId;
  };

  getDeviceDetails() {
    let browser = "";
    let device = "";
    let version = "";
    if (reactDeviceDetect.isMobile) {
      device = reactDeviceDetect.mobileModel;
      browser = reactDeviceDetect.browserName;
      version = reactDeviceDetect.fullBrowserVersion;
    } else if (reactDeviceDetect.isDesktop) {
      device = reactDeviceDetect.osName;
      browser = reactDeviceDetect.browserName;
      version = reactDeviceDetect.fullBrowserVersion;
    }

    return device + " using " + browser + ", version " + version;
  }

  getPaymentFailButton(attempt) {
    if (attempt < 4) {
      return (
        <NavLink
          to="/accountManagement"
          className="nav-link"
          onClick={this.handlePopupClose}
        >
          <button
            style={{
              backgroundColor: "#59A9F3",
              color: "white",
              border: "none",
              height: "40px",
              width: "200px",
              borderRadius: "5px",
            }}
          >
            <p style={{ margin: "auto", padding: "auto" }}>
              {localizationStrings.PopupButton}
            </p>
          </button>
        </NavLink>
      );
    } else {
      return (
        <button
          style={{
            backgroundColor: "#59A9F3",
            color: "white",
            border: "none",
            height: "40px",
            width: "200px",
            borderRadius: "5px",
          }}
          onClick={this.handlePopupClose}
        >
          <p style={{ margin: "auto", padding: "auto" }}>
            {localizationStrings.PopupButtonClose}
          </p>
        </button>
      );
    }
  }
  spilit(text) {
    if (text.includes("---")) {
      const parts = text.split("---");
      const firstPart = parts[0];
      const secondPart = parts[1];
      const Address = parts[2];
      return { Address };
    } else {
      const firstPart = " ";
      const secondPart = " ";
      const Address = text;
      return { Address };
    }
  }
  async handlePopupOpen2(accessData) {
    const notificationsRef = fire
      .database()
      .ref("individualNotifications")
      .child(auth.currentUser.uid);
    const snapshot = await notificationsRef.once("value");
    let targetKey = null;

    snapshot.forEach((childSnapshot) => {
      const key = childSnapshot.key;
      const data = childSnapshot.val();
      const splitTitle = accessData.title.split(" - ");
      const modifiedAccessTitle =
        splitTitle.length > 1 ? splitTitle[1] : accessData.title;

      if (
        data.title === accessData.title ||
        data.title === modifiedAccessTitle
      ) {
        targetKey = key;

        const isRead = childSnapshot.val()?.isRead;
        if (isRead === undefined || isRead === null) {
          notificationsRef.child(targetKey).update({
            isRead: true,
          });
        }
      }
    });

    this.setState({
      showPopup: true,
    });
  }

  async handlePopupOpen(accessData) {
    //  console.log(`snapkey : ${accessData.snapKey}`)
    // console.log(`user uid: ${auth.currentUser.uid}`)
    //   console.log(`key : ${accessData.key}`)
    //   console.log(`data: ${JSON.stringify(accessData)}`)

    // update firebase 'individualNotifications' isRead to true
    await fire
      .database()
      .ref("individualNotifications")
      .child(auth.currentUser.uid)
      .child(accessData.snapKey)
      .update({
        isRead: true,
      });

    this.setState({
      showPopup: true,
    });
  }

  handlePopupClose() {
    this.setState({
      showPopup: false,
    });

    this.props.refresh();
  }

  async handleApproveButton() {
    let data = this.state.accessData;
    const approvalURL =
      "https://us-central1-egeetouchindustrial.cloudfunctions.net/newDeviceLoginApprovalStatus";

    let dataToSend = {
      email: data.userEmail,
      adminEmail: auth.currentUser.email,
      ownerUid: auth.currentUser.uid,
      loginDate: Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      }).format(data.time),
      loginDeviceDetails:
        data.deviceModel === undefined || data.deviceModel === null
          ? localizationStrings.noDeviceTitle
          : data.deviceModel,
      approvalStatus: "APPROVED",
      language: this.state.currentLanguage,
    };

    if (this.state.currentLanguage === "ja") {
      dataToSend = {
        email: data.userEmail,
        adminEmail: auth.currentUser.email,
        ownerUid: auth.currentUser.uid,
        loginDate:
          Intl.DateTimeFormat("ja-JP", {
            year: "numeric",
            month: "long",
            day: "numeric",
          }).format(data.time) +
          Intl.DateTimeFormat("ja-JP", {
            hour: "2-digit",
            minute: "2-digit",
          }).format(data.time),
        loginDeviceDetails:
          data.deviceModel === undefined || data.deviceModel === null
            ? localizationStrings.noDeviceTitle
            : data.deviceModel,
        approvalStatus: "APPROVED",
        language: this.state.currentLanguage,
      };
    }

    // console.log("email: " + dataToSend.email);
    // console.log("ownerUid: " + dataToSend.ownerUid);
    // console.log("loginDate: " + dataToSend.loginDate);
    // console.log("loginDeviceDetails: " + dataToSend.loginDeviceDetails);
    // console.log("approvalStatus: " + dataToSend.approvalStatus);
    // console.log("language: " + dataToSend.language);

    await fire
      .database()
      .ref("deviceChangeRequest")
      .child(auth.currentUser.uid)
      .child(await this.getUserId(data.userEmail))
      .once("value")
      .then((snapshot) => {
        if (snapshot.exists) {
          // console.log("Snap deviceUID: " + snap.val().deviceUID);
          // console.log("Access deviceUID: " + this.state.accessData.deviceUID);
          if (snapshot.val().deviceUID === this.state.accessData.deviceUID) {
            // let userUID = this.state.accessData.userUID;

            fetch(approvalURL, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(dataToSend),
            });

            fire
              .database()
              .ref("userLoginDetails")
              .child("MobileAppLogins")
              .child(snapshot.key)
              .update({
                status: "APPROVED",
              });

            // console.log("snapkey: " + snapshot.key);

            fire
              .database()
              .ref("deviceChangeRequest")
              .child(auth.currentUser.uid)
              .child(snapshot.key)
              .update({
                status: "APPROVED",
              });

            fire
              .database()
              .ref("individualNotifications")
              .child(auth.currentUser.uid)
              .child(this.state.accessData.snapKey)
              .update({
                isRead: true,
                status: "APPROVED",
              });

            // Insert into activity logs that the super admin approved the request of "user"
            let activityLogsDB = fire
              .database()
              .ref("activityLogs")
              .child(auth.currentUser.uid);
            let key = activityLogsDB.push().key;

            fire
              .database()
              .ref("activityLogs")
              .child(auth.currentUser.uid) // get uid from auth person object
              .child(key)
              .set({
                key: key,
                Type: 0,
                description:
                  "Approved new login device access for " +
                  this.state.accessData.userEmail,
                email: auth.currentUser.email,
                time: Math.floor(new Date()),
                userUID: auth.currentUser.uid,
                device: this.getDeviceDetails(),
              })
              .then(() => {
                this.setState({
                  showPopup: false,
                });
                //refresh requests list
                this.props.refresh();
              });
          } else {
            // console.log("Does not match any device Change request");
            // console.log("Current snapKey: " + this.state.accessData.snapKey);

            fire
              .database()
              .ref("individualNotifications")
              .child(auth.currentUser.uid)
              .child(this.state.accessData.snapKey)
              .update({
                isRead: true,
                status: "INVALID",
              });

            // Insert into activity logs that the super admin approved the request of "user"
            let activityLogsDB = fire
              .database()
              .ref("activityLogs")
              .child(auth.currentUser.uid);
            let key = activityLogsDB.push().key;

            fire
              .database()
              .ref("activityLogs")
              .child(auth.currentUser.uid) // get uid from auth person object
              .child(key)
              .set({
                key: key,
                Type: 0,
                description:
                  "Invalid new login device access for " +
                  this.state.accessData.userEmail,
                email: auth.currentUser.email,
                time: Math.floor(new Date()),
                userUID: auth.currentUser.uid,
                device: this.getDeviceDetails(),
              })
              .then(() => {
                this.setState({
                  showPopup: false,
                });
                //refresh requests list
                this.props.refresh();
              });
          }
        }
      });
  }

  async handleDenyButton() {
    let data = this.state.accessData;
    const approvalURL =
      "https://us-central1-egeetouchindustrial.cloudfunctions.net/newDeviceLoginApprovalStatus";

    let dataToSend = {
      email: data.userEmail,
      adminEmail: auth.currentUser.email,
      ownerUid: auth.currentUser.uid,
      loginDate: Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      }).format(data.time),
      loginDeviceDetails:
        data.deviceModel === undefined || data.deviceModel === null
          ? localizationStrings.noDeviceTitle
          : data.deviceModel,
      approvalStatus: "DENIED",
      language: this.state.currentLanguage,
    };

    if (this.state.currentLanguage === "ja") {
      dataToSend = {
        email: data.userEmail,
        adminEmail: auth.currentUser.email,
        ownerUid: auth.currentUser.uid,
        loginDate:
          Intl.DateTimeFormat("ja-JP", {
            year: "numeric",
            month: "long",
            day: "numeric",
          }).format(data.time) +
          Intl.DateTimeFormat("ja-JP", {
            hour: "2-digit",
            minute: "2-digit",
          }).format(data.time),
        loginDeviceDetails:
          data.deviceModel === undefined || data.deviceModel === null
            ? localizationStrings.noDeviceTitle
            : data.deviceModel,
        approvalStatus: "DENIED",
        language: this.state.currentLanguage,
      };
    }

    // console.log("email: " + dataToSend.email);
    // console.log("ownerUid: " + dataToSend.ownerUid);
    // console.log("loginDate: " + dataToSend.loginDate);
    // console.log("loginDeviceDetails: " + dataToSend.loginDeviceDetails);
    // console.log("approvalStatus: " + dataToSend.approvalStatus);
    // console.log("language: " + dataToSend.language);

    await fire
      .database()
      .ref("deviceChangeRequest")
      .child(auth.currentUser.uid)
      .child(await this.getUserId(data.userEmail))
      .once("value")
      .then((snapshot) => {
        if (snapshot.exists) {
          // console.log("Snap deviceUID: " + snap.val().deviceUID);
          // console.log("Access deviceUID: " + this.state.accessData.deviceUID);
          if (snapshot.val().deviceUID === this.state.accessData.deviceUID) {
            // let userUID = this.state.accessData.userUID;

            fetch(approvalURL, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(dataToSend),
            });

            fire
              .database()
              .ref("userLoginDetails")
              .child("MobileAppLogins")
              .child(snapshot.key)
              .update({
                status: "DENIED",
              });

            fire
              .database()
              .ref("deviceChangeRequest")
              .child(auth.currentUser.uid)
              .child(snapshot.key)
              .update({
                status: "DENIED",
              });

            fire
              .database()
              .ref("individualNotifications")
              .child(auth.currentUser.uid)
              .child(this.state.accessData.snapKey)
              .update({
                isRead: true,
                status: "DENIED",
              });

            // Insert into activity logs that the super admin approved the request of "user"
            let activityLogsDB = fire
              .database()
              .ref("activityLogs")
              .child(auth.currentUser.uid);
            let key = activityLogsDB.push().key;

            fire
              .database()
              .ref("activityLogs")
              .child(auth.currentUser.uid) // get uid from auth person object
              .child(key)
              .set({
                key: key,
                Type: 0,
                description:
                  "Denied new login device access for " +
                  this.state.accessData.userEmail,
                email: auth.currentUser.email,
                time: Math.floor(new Date()),
                userUID: auth.currentUser.uid,
                device: this.getDeviceDetails(),
              })
              .then(() => {
                this.setState({
                  showPopup: false,
                });
                //refresh requests list
                this.props.refresh();
              });
          } else {
            // console.log("Does not match any device Change request");
            // console.log("Current snapKey: " + snapshot.key);

            fire
              .database()
              .ref("individualNotifications")
              .child(auth.currentUser.uid)
              .child(this.state.accessData.snapKey)
              .update({
                isRead: true,
                status: "INVALID",
              });

            // Insert into activity logs that the super admin approved the request of "user"
            let activityLogsDB = fire
              .database()
              .ref("activityLogs")
              .child(auth.currentUser.uid);
            let key = activityLogsDB.push().key;

            fire
              .database()
              .ref("activityLogs")
              .child(auth.currentUser.uid) // get uid from auth person object
              .child(key)
              .set({
                key: key,
                Type: 0,
                description:
                  "Invalid new login device access for " +
                  this.state.accessData.userEmail,
                email: auth.currentUser.email,
                time: Math.floor(new Date()),
                userUID: auth.currentUser.uid,
                device: this.getDeviceDetails(),
              })
              .then(() => {
                this.setState({
                  showPopup: false,
                });
                //refresh requests list
                this.props.refresh();
              });
          }
        }
      });
  }

  getPackageCost = (cost, currency) => {
    var currency_symbols = {
      usd: "$", // US Dollar
      eur: "€", // Euro
      crc: "₡", // Costa Rican Colón
      gbp: "£", // British Pound Sterling
      ils: "₪", // Israeli New Sheqel
      inr: "₹", // Indian Rupee
      jpy: "¥", // Japanese Yen
      krw: "₩", // South Korean Won
      ngn: "₦", // Nigerian Naira
      php: "₱", // Philippine Peso
      pln: "zł", // Polish Zloty
      pyg: "₲", // Paraguayan Guarani
      thb: "฿", // Thai Baht
      uah: "₴", // Ukrainian Hryvnia
      vnd: "₫", // Vietnamese Dong
    };

    if (currency === "jpy") {
      return currency_symbols[currency] + cost;
    } else {
      return currency_symbols[currency] + (cost / 100).toFixed(2);
    }
  };

  dateTimeFormat(time, day = true) {
    if (day) {
      if (localizationStrings.getLanguage() === "ja") {
        customLog(
          new Intl.DateTimeFormat("ja-JP", { era: "long" }).format(time)
        );
        customLog(
          new Intl.DateTimeFormat("ja-JP", {
            hour: "2-digit",
            minute: "2-digit",
          }).format(time)
        );
        customLog(Date.now());
        var japanDate = new Intl.DateTimeFormat("ja-JP", {
          year: "numeric",
          month: "long",
          day: "numeric",
        }).format(time);
        var japanTime = new Intl.DateTimeFormat("ja-JP", {
          hour: "2-digit",
          minute: "2-digit",
        }).format(time);
        return japanDate + japanTime;
      } else {
        // customLog(new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(time));
        return <TimeStamp time={time / 1000} format="full" includeDay />;
      }
    } else {
      if (localizationStrings.getLanguage() === "ja") {
        customLog(
          new Intl.DateTimeFormat("ja-JP", { era: "long" }).format(time)
        );
        customLog(
          new Intl.DateTimeFormat("ja-JP", {
            hour: "2-digit",
            minute: "2-digit",
          }).format(time)
        );
        customLog(Date.now());
        var japanDate = new Intl.DateTimeFormat("ja-JP", {
          year: "numeric",
          month: "long",
          day: "numeric",
        }).format(time);
        var japanTime = new Intl.DateTimeFormat("ja-JP", {
          hour: "2-digit",
          minute: "2-digit",
        }).format(time);
        return japanDate + japanTime;
      } else {
        // customLog(new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(time));
        return <TimeStamp time={time / 1000} format="full" />;
      }
    }
  }

  getAttemptMessage(attempt) {
    if (attempt < 4) {
      return (
        <p style={{ textAlign: "center", width: "80%", margin: "auto" }}>
          {this.state.accessData.access.attempt < 3
            ? localizationStrings.attemptMessage3Day
            : localizationStrings.attemptMessage1Day}
        </p>
      );
    } else {
      return (
        <p
          style={{
            textAlign: "center",
            width: "80%",
            margin: "auto",
            color: "#FF2121",
          }}
        >
          {localizationStrings.attemptMessageNone}
        </p>
      );
    }
  }

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    //! FOR LANGUAGE SETTING
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }

    const accessData = this.state.accessData;

    // return accessData.type;

    if (accessData.type === 1) {
      return (
        <div>
          <button
            onClick={() => {
              this.handlePopupOpen(accessData);
            }}
            className={"approveBtn hoverEffect"}
          >
            {localizationStrings.viewDetailsTitle}
          </button>

          {/* //! Popup for Details */}
          <Modal
            show={this.state.showPopup}
            onHide={this.handlePopupClose}
            dialogClassName="modal-60w"
          >
            <Modal.Header closeButton>
              <Modal.Title style={{ textAlign: "center" }}>
                {localizationStrings.detailsNotifType}
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "center",
                }}
              >
                <h4 style={{ width: "80%", textAlign: "center" }}>
                  {accessData.popupDescription}
                </h4>
              </div>

              <div style={{ width: "100%" }}>
                <img
                  style={{
                    display: "block",
                    margin: "auto",
                    height: "150px",
                    width: "150px",
                  }}
                  src={lockAccess}
                  alt="lockAccess"
                />
              </div>

              <h4 style={{ textAlign: "center" }}>
                {localizationStrings.detailsTitle}
              </h4>

              {/* Table for data of details */}
              <table
                style={{
                  textAlign: "left",
                  width: "60%",
                  justifyContent: "center",
                  margin: "auto",
                }}
              >
                <tbody>
                  <tr>
                    <td>{localizationStrings.SenderHeader}</td>
                    <td>{accessData.userEmail}</td>
                  </tr>

                  <tr>
                    <td>{localizationStrings.TimeHeader}</td>
                    <td>{this.dateTimeFormat(accessData.time)}</td>
                  </tr>
                </tbody>
              </table>
              <br />
              <br />
            </Modal.Body>
          </Modal>
        </div>
      );
    } else if (accessData.type === 2) {
      if (accessData.status === "PENDING") {
        return (
          <div>
            <button
              onClick={() => {
                this.handlePopupOpen(accessData);
              }}
              className={"approveBtn hoverEffect pendingBtn"}
            >
              {localizationStrings.approvalPending}
            </button>

            {/* //! Popup for Approval */}
            <Modal
              show={this.state.showPopup}
              onHide={this.handlePopupClose}
              dialogClassName="modal-50w"
            >
              <Modal.Header closeButton>
                <Modal.Title style={{ textAlign: "center" }}>
                  {localizationStrings.loginNotifType}
                </Modal.Title>
              </Modal.Header>

              <Modal.Body>
                <h4 style={{ width: "100%", textAlign: "center" }}>
                  {accessData.popupDescription}
                </h4>
                <br />
                <div style={{ width: "100%" }}>
                  <img
                    style={{
                      display: "block",
                      margin: "auto",
                      height: "150px",
                    }}
                    src={authorizeIMG}
                    alt="AuthorizeIMG"
                  />
                </div>
                <br />
                <h4 style={{ width: "100%", textAlign: "center" }}>
                  {localizationStrings.detailsTitle}
                </h4>

                {/* Table for data of details */}
                <table
                  style={{
                    textAlign: "left",
                    width: "60%",
                    justifyContent: "center",
                    margin: "auto",
                  }}
                >
                  <tbody>
                    <tr>
                      <td>{localizationStrings.EmailHeader}</td>
                      <td>{accessData.userEmail}</td>
                    </tr>

                    <tr>
                      <td>{localizationStrings.DeviceHeader}</td>
                      <td>
                        {accessData.deviceModel === undefined ||
                        accessData.deviceModel === null
                          ? localizationStrings.noDeviceTitle
                          : accessData.deviceModel}
                      </td>
                    </tr>

                    <tr>
                      <td>{localizationStrings.TimeHeader}</td>
                      <td>{this.dateTimeFormat(accessData.time)}</td>
                    </tr>
                  </tbody>
                </table>
                <br />
                <br />
                {/* Approval request: Approve/Deny buttons */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-around",
                    width: "100%",
                    margin: "auto",
                  }}
                >
                  <button
                    style={{
                      backgroundColor: "green",
                      color: "white",
                      border: "none",
                      height: "40px",
                      width: "300px",
                      borderRadius: "5px",
                    }}
                    onClick={() => {
                      this.handleApproveButton(accessData);
                    }}
                  >
                    {localizationStrings.allow}
                  </button>
                  <button
                    style={{
                      backgroundColor: "red",
                      color: "white",
                      border: "none",
                      height: "40px",
                      width: "300px",
                      borderRadius: "5px",
                    }}
                    onClick={() => {
                      this.handleDenyButton(accessData);
                    }}
                  >
                    {localizationStrings.deny}
                  </button>
                </div>
                <br />
                <br />
              </Modal.Body>
            </Modal>
          </div>
        );
      } else {
        let btnStyle;

        if (accessData.status === "APPROVED") {
          btnStyle = {
            color: "black",
          };
        } else if (
          accessData.status === "DENIED" ||
          accessData.status === "EXPIRED" ||
          accessData.status === "INVALID"
        ) {
          btnStyle = {
            color: "red",
          };
        }

        return (
          <div>
            <button
              onClick={() => {
                this.handlePopupOpen(accessData);
              }}
              className={"approveBtn hoverEffect"}
              style={btnStyle}
            >
              {accessData.status === "DENIED"
                ? localizationStrings.deniedButton
                : accessData.status === "EXPIRED"
                ? localizationStrings.expiredButton
                : accessData.status === "INVALID"
                ? localizationStrings.invalidButton
                : accessData.status === "PENDING"
                ? localizationStrings.pendingButton
                : accessData.status === "APPROVED"
                ? localizationStrings.approvedButton
                : ""}
            </button>

            {/* //! Popup for Approval */}
            {
              //! if Approved, hide approve/deny button, show approval/deny status
            }
            <Modal
              show={this.state.showPopup}
              onHide={this.handlePopupClose}
              dialogClassName="modal-60w"
            >
              <Modal.Header closeButton>
                <Modal.Title style={{ textAlign: "center" }}>
                  {localizationStrings.loginNotifType}
                </Modal.Title>
              </Modal.Header>

              <Modal.Body>
                <h4 style={{ width: "100%", textAlign: "center" }}>
                  {accessData.popupDescription}
                </h4>

                <div style={{ width: "100%" }}>
                  <img
                    style={{
                      display: "block",
                      margin: "auto",
                      height: "150px",
                    }}
                    src={authorizeIMG}
                    alt="AuthorizeIMG"
                  />
                </div>

                <h4 style={{ textAlign: "center" }}>
                  {localizationStrings.detailsTitle}
                </h4>

                {/* Table for data of details */}
                <table
                  style={{
                    textAlign: "left",
                    width: "60%",
                    justifyContent: "center",
                    margin: "auto",
                  }}
                >
                  <tbody>
                    <tr>
                      <td>{localizationStrings.EmailHeader}</td>
                      <td>{accessData.userEmail}</td>
                    </tr>

                    <tr>
                      <td>{localizationStrings.DeviceHeader}</td>
                      <td>
                        {accessData.deviceModel === undefined ||
                        accessData.deviceModel === null
                          ? localizationStrings.noDeviceTitle
                          : accessData.deviceModel}
                      </td>
                    </tr>

                    <tr>
                      <td>{localizationStrings.TimeHeader}</td>
                      <td>{this.dateTimeFormat(accessData.time)}</td>
                    </tr>

                    <tr>
                      <td>{localizationStrings.StatusHeader}</td>
                      <td>
                        {accessData.status === "DENIED"
                          ? localizationStrings.deniedButton
                          : accessData.status === "EXPIRED"
                          ? localizationStrings.expiredButton
                          : accessData.status === "INVALID"
                          ? localizationStrings.invalidButton
                          : accessData.status === "PENDING"
                          ? localizationStrings.pendingButton
                          : accessData.status === "APPROVED"
                          ? localizationStrings.approvedButton
                          : ""}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <br />
                <br />
              </Modal.Body>
            </Modal>
          </div>
        );
      }
    } else if (accessData.type === 3) {
      return (
        <div>
          <button
            onClick={() => {
              this.handlePopupOpen(accessData);
            }}
            className={"approveBtn hoverEffect"}
          >
            {localizationStrings.viewDetailsTitle}
          </button>

          {/* //! Popup for Details */}
          <Modal
            show={this.state.showPopup}
            onHide={this.handlePopupClose}
            dialogClassName="modal-60w"
          >
            <Modal.Header closeButton>
              <Modal.Title style={{ textAlign: "center" }}>
                {localizationStrings.paymentFailNotifType}
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "center",
                }}
              >
                <h4 style={{ width: "80%", textAlign: "center" }}>
                  {localizationStrings.paymentFailPopupDescription}
                </h4>
              </div>

              <div
                style={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "center",
                }}
              >
                <img
                  style={{
                    display: "block",
                    margin: "20 auto 20 auto",
                    height: "100px",
                  }}
                  src={paymentFailPopup}
                  alt="paymentFailPopup"
                />
              </div>

              <h4 style={{ textAlign: "center" }}>
                {localizationStrings.paymentDetailsTitle}
              </h4>

              {/* Table for data of details */}
              <table
                style={{
                  textAlign: "left",
                  width: "60%",
                  justifyContent: "center",
                  margin: "auto",
                }}
              >
                <tbody>
                  <tr>
                    <td>{localizationStrings.planDetail}</td>
                    <td>
                      {this.state.currentPlan}
                      {" plan"}
                    </td>
                  </tr>
                  <tr>
                    <td>{localizationStrings.amountDetail}</td>
                    <td>
                      {this.getPackageCost(
                        accessData.access.amount,
                        accessData.access.currency
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>{localizationStrings.cardDetail}</td>
                    <td>
                      {"**** **** **** "}
                      {accessData.access.cardLast4}
                    </td>
                  </tr>
                  <tr>
                    <td>{localizationStrings.dateDetail}</td>
                    <td>{this.dateTimeFormat(accessData.time, false)}</td>
                  </tr>
                  {/* <tr>
                    <td>{"Currency: "}</td>
                    <td>{accessData.access.currency}</td>
                  </tr> */}
                </tbody>
              </table>
              <br />
              {this.getAttemptMessage(this.state.accessData.access.attempt)}
              <br />
              <p style={{ textAlign: "center", width: "80%", margin: "auto" }}>
                {this.state.accessData.access.attempt > 3
                  ? ""
                  : localizationStrings.attemptMessageNote}
              </p>
              <br />
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  margin: "auto",
                  justifyContent: "space-around",
                }}
              >
                {this.getPaymentFailButton(
                  this.state.accessData.access.attempt
                )}
              </div>
              <br />
              <br />
            </Modal.Body>
          </Modal>
        </div>
      );
    } else if (accessData.type === 4) {
      return (
        <div>
          <button
            onClick={() => {
              this.handlePopupOpen(accessData);
            }}
            className={"approveBtn hoverEffect"}
          >
            {localizationStrings.viewDetailsTitle}
          </button>

          {/* //! Popup for Details */}
          <Modal
            show={this.state.showPopup}
            onHide={this.handlePopupClose}
            dialogClassName="modal-60w"
          >
            <Modal.Header closeButton>
              <Modal.Title style={{ textAlign: "center" }}>
                {localizationStrings.popupTitle}
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "center",
                }}
              >
                <h4 style={{ width: "80%", textAlign: "center" }}>
                  {accessData.name + localizationStrings.emailDescription}
                </h4>
              </div>

              <div
                style={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "center",
                }}
              >
                <img
                  style={{
                    display: "block",
                    margin: "20 auto 20 auto",
                    height: "100px",
                  }}
                  src={UserSettingsPopUp}
                  alt="Settings Update Logo"
                />
              </div>

              <h4 style={{ textAlign: "center" }}>
                {localizationStrings.detailsTitle}
              </h4>

              {/* Table for data of details */}
              <table
                style={{
                  textAlign: "left",
                  width: "60%",
                  justifyContent: "center",
                  margin: "auto",
                }}
              >
                <tbody>
                  <tr>
                    <td>{localizationStrings.oldEmailHeader}</td>
                    <td>{accessData.access.oldEmail}</td>
                  </tr>
                  <tr>
                    <td>{localizationStrings.newEmailHeader}</td>
                    <td>{accessData.access.newEmail}</td>
                  </tr>
                  <tr>
                    <td>{localizationStrings.emailUpdatedOn}</td>
                    <td>{this.dateTimeFormat(accessData.time, false)}</td>
                  </tr>
                </tbody>
              </table>
            </Modal.Body>
          </Modal>
        </div>
      );
    } else if (accessData.type === 5) {
      return (
        <div>
          <button
            onClick={() => {
              this.handlePopupOpen(accessData);
            }}
            className={"approveBtn hoverEffect"}
          >
            {localizationStrings.viewDetailsTitle}
          </button>

          {/* //! Popup for Details */}
          <Modal
            show={this.state.showPopup}
            onHide={this.handlePopupClose}
            dialogClassName="modal-60w"
          >
            <Modal.Header closeButton>
              <Modal.Title style={{ textAlign: "center" }}>
                {localizationStrings.removedMember}
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "center",
                }}
              >
                <h4 style={{ width: "80%", textAlign: "center" }}>
                  {localizationStrings.removedMemberTitle +
                    accessData.superAdminName +
                    localizationStrings.memberListTitle}
                </h4>
              </div>

              <div
                style={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "center",
                }}
              >
                <img
                  style={{
                    display: "block",
                    margin: "20 auto 20 auto",
                    height: "100px",
                  }}
                  src={memberRemoveIcon}
                  alt="Member Remove"
                />
              </div>

              {/* <h5 style={{textAlign: "center"}}>{localizationStrings.removedMemberInformationDescription1}</h5> */}

              <div
                style={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "space-evenly",
                  flexDirection: "column",
                }}
              >
                <h5 style={{ width: "100%", textAlign: "center" }}>
                  {localizationStrings.removedMemberInformationDescription1}
                </h5>
                <h5 style={{ width: "100%", textAlign: "center" }}>
                  {localizationStrings.removedMemberInformationDescription2}
                </h5>
              </div>

              {/* Table for data of details */}
              {/* <table style={{textAlign: "left", width: "60%", justifyContent: "center", margin: "auto"}}>
                <tbody> */}
              {/* <tr>
                    <td>Test</td>
                    <td>test data</td>
                  </tr> */}
              {/* <tr>
                    <td>{localizationStrings.superAdminHeader}</td>
                    <td>{accessData.superAdminName}</td>
                  </tr>
                  <tr>
                    <td>{localizationStrings.removedMemberDescription}</td>
                    <td>{this.dateTimeFormat(accessData.time, false)}</td>
                  </tr>
                </tbody> */}
              {/* </table> */}
            </Modal.Body>
          </Modal>
        </div>
      );
    } else if (accessData.type === 102) {
      let { Address } = this.spilit(accessData.tableDescription);

      return (
        <div>
          <button
            onClick={() => {
              this.handlePopupOpen2(accessData);
            }}
            className={"approveBtn hoverEffect"}
          >
            {localizationStrings.viewDetailsTitle}
          </button>

          {/* //! Popup for Details */}
          <Modal
            show={this.state.showPopup}
            onHide={this.handlePopupClose}
            dialogClassName="modal-60w"
          >
            <Modal.Header closeButton>
              <Modal.Title style={{ textAlign: "center" }}>
                {localizationStrings.ImpactAlert + " " + accessData.title}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "center",
                }}
              >
                <img
                  style={{
                    display: "block",
                    margin: "20 auto 20 auto",
                    height: "100px",
                  }}
                  src={ImpactAlert}
                  alt="ImpactAlert"
                />
              </div>
              <div style={{ textAlign: "center" }}>
                <p>{localizationStrings.lockimpact}</p>
                <h3>{localizationStrings.Serial_Number_title}</h3>
                <p>{accessData.title}</p>
                <h3>{localizationStrings.Time_title}</h3>
                <p>{this.dateTimeFormat(accessData.time, false)}</p>
                <h3>{localizationStrings.Address_title}</h3>
                <p>{Address}</p>
              </div>
            </Modal.Body>
          </Modal>
        </div>
      );
    } else {
      // if not any type => return null
      return null;
    }
  }
}

export default ApprovalBtn;
